<script setup lang="ts">
import { coreDataTypes } from "~/features/python/ch2/data-types/data/dataTypes.content";
</script>

<template>
  <section class="space-y-4">
    <h2 class="text-lg font-semibold text-slate-900">Core Data Types</h2>
    <div class="space-y-4">
      <article
        v-for="item in coreDataTypes"
        :key="item.id"
        class="rounded-3xl border border-slate-200 bg-white p-5"
      >
        <div class="flex items-center justify-between gap-3">
          <div>
            <h3 class="text-base font-semibold text-slate-900">{{ item.title }}</h3>
            <p class="text-sm text-slate-500">{{ item.pythonName }}</p>
          </div>
          <span class="rounded-full bg-sky-50 px-3 py-1 text-xs font-medium text-sky-700">{{ item.pythonName }}</span>
        </div>
        <p class="mt-3 text-sm leading-7 text-slate-700">{{ item.explanation }}</p>
        <p class="mt-2 text-sm text-slate-600">{{ item.realWorldExample }}</p>
        <pre class="mt-3 overflow-x-auto rounded-2xl bg-slate-950 p-4 text-sm leading-6 text-sky-100"><code>{{ item.code }}</code></pre>
      </article>
    </div>
  </section>
</template>
